import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const Heading: FC = () => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <Label className={styles.title} variant="h2-centered" color="primary">
        We&apos;re reimagining what it means to take care of your home
      </Label>
      <Label className={styles.subtitle} variant="s2-centered" color="primary">
        As busy homeowners ourselves, we have an extremely simple mission:
        return the time, money and energy that home maintenance can take from
        your life.
      </Label>
    </Content>
  );
};

export default Heading;
